import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/parkour/Index.vue')

export const indexRoute: RouteConfig = {
  path: '/activity/parkour',
  name: 'activity_parkour',
  component: Index,
  meta: {
    title: '天天跑酷',
    expiryDate: '2024-04-09',
  },
}

export default [indexRoute]
